// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"906c8871","312":"abe02d39","502":"eeff5f85","509":"6b761dbd","677":"964c3a17","709":"42cb46af","837":"e84e206d","845":"6f1976d5","937":"f47c65ae"}[chunkId] + ".chunk.js";
};